<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div class="card ">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4> Assignments</h4>
                <div class="breadcrumb-sub-header">
                  <router-link to="/dashboard">Dashboard</router-link>
                  \   Assignments
                </div>
              </div>
<!--              <div class="breadcrumb-right">
                <v-btn
                       @click="createAssignment()"
                       class="mt-4 btn btn-primary  mr-1"
                       dark>
                  <i class="fa fa-plus"></i>
                  Add assignment
                </v-btn>

              </div>-->
            </div>
          </div>
          <div class="card-body">
            <div class="search-wrapper border-outline mb-5 px-3 py-5 d-sm-flex justify-content-start">
              <div class="row">
                <div class="col-md-3">
                  <v-text-field
                      outlined
                      v-model="search.title"
                      dense
                      label="Select title"
                  >
                  </v-text-field>
                </div>
                <div class="col-md-2">
                  <v-select
                      outlined
                      :loading="loading"
                      :items="lesson_plans"
                      v-model="search.lesson_planner_id"
                      @change="getTopics(search.lesson_planner_id)"
                      dense
                      item-text="title"
                      item-value="id"
                      label="Select lesson plan"
                  >
                  </v-select>
                </div>
                <div class="col-md-2">
                  <v-select
                      :loading="isBusy"
                      outlined
                      :items="lesson_plan_topics"
                      v-model="search.unit_id"
                      @change="getTopicLessons(search.unit_id)"
                      dense
                      item-text="title"
                      item-value="id"
                      label="Select topic"
                  >
                  </v-select>
                </div>
                <div class="col-md-2">
                  <v-select
                      :loading="isBusy"
                      outlined
                      :items="lessons"
                      v-model="search.lesson_id"
                      dense
                      item-text="title"
                      item-value="id"
                      label="Select lesson"
                  >
                  </v-select>
                </div>
                <div class="col-md-2">
                  <v-select
                      :loading="isBusy"
                      outlined
                      :items="dueDates"
                      v-model="search.due_date"
                      dense
                      item-text="name"
                      item-value="value"
                      label="Due date"
                  >
                  </v-select>
                </div>
                <div class="col-md-2">
                  <v-select
                      :loading="isBusy"
                      outlined
                      :items="statuses"
                      v-model="search.active"
                      dense
                      item-text="title"
                      item-value="value"
                      label="Status"
                  >
                  </v-select>
                </div>

                <v-col cols="12" md="12" class="text-right">
                  <v-btn
                      @click="getAllAssignment()"
                      class="btn btn-primary btn-search "
                      :loading="assignmentLoading"
                  >
                    <v-icon small elevation="2" outlined>fas fa-search</v-icon>&nbsp;
                    Search
                  </v-btn>
                </v-col>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-stripe">
                <thead>
                <tr class="px-3">
                  <th>Title</th>
                  <th>Due date</th>
                  <th>Course</th>
                  <th>Lesson planner</th>
                  <th>Class</th>
                  <th>Program</th>
                  <th>Semester/year</th>
                  <th>Batch</th>
                  <th>Submission</th>
                  <th>Action</th>
                </tr>

                </thead>
                <tbody>
                <tr v-show="assignments.length > 0" v-for="(assignment, index) of assignments" :key="index">
                  <td>
                    <a @click="assignmentSummary(assignment)"
                       class="text-primary font-weight-bolder text-hover-primary mb-1">
                     {{ assignment.title }}
                    </a> &nbsp; <i class="fas fa-circle"
                             :class="assignment.is_active?'dot-active':'dot-inactive'"></i>
<!--                    <router-link :to="{ name:'assignment-summary',params:{assignment_id: assignment.id}}">
                      {{ assignment.title }}
                    </router-link> &nbsp; &nbsp;-->

                  </td>
                  <td>
                      <span v-if="assignment.due_date">
                      {{ assignment.due_date | moment("dddd, MMMM Do YYYY")  }}
                      </span>
                    <span v-else>
                      N/A
                      </span>

                  </td>

                  <td>
                    <span v-if="assignment.course">
                    {{ assignment.course.title }}
                    </span>
                    <span v-else>
                    N/A
                    </span>
                  <td>
                    {{ assignment.lesson_planner_title  || 'N/A'}}
                  </td>
                  <td>
                    {{ assignment.academic_class  || 'N/A'}}
                  </td>

                  <td>
                      <span v-if="assignment.course">
                      {{ assignment.course.program.title }}
                      </span>
                    <span v-else>
                      N/A
                      </span>
                  </td>
                  <td>
                      <span v-if="assignment.course">
                      {{ assignment.course.grade.title }}
                      </span>
                    <span v-else>
                      N/A
                      </span>

                  </td>
                  <td>
                    {{ assignment.academic_year  || 'N/A'}}
                  </td>
                  <td>8/20</td>
                  <td>
                    <div class="kt-widget__toolbar">

                      <b-dropdown
                          size="sm"
                          variant="link"
                          toggle-class="custom-v-dropdown"
                          no-caret
                          right
                          no-flip
                          text="Actions"
                      >
                        <template v-slot:button-content>
                          <a href="#" class="" data-toggle="dropdown">
                            <!-- <span class="svg-icon svg-icon-success svg-icon-2x">-->
                            <!--begin::Svg Icon-->
                            <i class="flaticon-more-1"></i>
                            <!--end::Svg Icon-->
                            <!-- </span>-->
                          </a>
                        </template>
                        <!--begin::Navigation-->
                        <div class="navi navi-hover">

                          <b-dropdown-text tag="div" class="navi-item">

                            <router-link :to="{name:'assignment-submission',params:{
                                assignment_id:assignment.id
                                }}" class="navi-link"
                            >
                                <span class="navi-icon">
                                <i class="flaticon-list-2"></i>
                                </span>
                              <span class="navi-text">Submissions</span>
                            </router-link>
                          </b-dropdown-text>
                          <b-dropdown-text tag="div" class="navi-item">
                            <router-link :to="{name:'assignment-edit',params:{
                                assignment_id:assignment.id
                                }}" class="navi-link"
                            >
                                <span class="navi-icon">
                                <i class="flaticon-edit"></i>
                                </span>
                              <span class="navi-text">Edit</span>
                            </router-link>

                          </b-dropdown-text>
                          <b-dropdown-text tag="div" class="navi-item"
                          >
                            <a href="#" class="navi-link"
                               @click.prevent="deleteAcademicYear(assignment.id)">
                                    <span class="navi-icon">
                                    <i class="flaticon-delete"></i>
                                    </span>
                              <span class="navi-text">Delete</span>
                            </a>
                          </b-dropdown-text>
                        </div>
                        <!--end::Navigation-->
                      </b-dropdown>
                    </div>


                  </td>
                </tr>
                <tr v-if="assignments.length == 0">
                  <td colspan="10" class="text-center">
                    <span class="font-weight-black">
                      No items found.
                    </span>
                  </td>
                </tr>
                </tbody>
              </table>
              <b-pagination
                  v-if="assignments.length > 0"
                  class="pull-right mt-7"
                  @input="getAllAssignment"
                  v-model="page"
                  :total-rows="total"
                  :per-page="perPage"
                  first-number
                  last-number
              ></b-pagination>
            </div>

          </div>
        </div>

      </div>
    </div>

  </v-app>
</template>
<script>
import AssignmentService from "@/core/services/assignement/AssignmentService";
import {AssignmentMixin} from "@/mixins/AssignmentMixin";
import AcademicClassTeacherService from "@/core/services/academic-class/class-teacher/AcademicClassTeacherService";
import LessonPlannerService from "@/core/services/lesson-planner/lesson-planner/LessonPlannerService";
import NewAssignment from "./NewAssignment";
import {SiteSettingMixin} from "@/mixins/SiteSettingMixin";

const assignmentService = new AssignmentService();
const lessonPlannerService = new LessonPlannerService();
const academicClassTeacherService = new AcademicClassTeacherService();

export default {
  name: "assignment",
  mixins: [AssignmentMixin,SiteSettingMixin],
  components: {},
  data() {
    return {
      page: null,
      total: null,
      perPage: null,
      closeOnClick: true,
      lesson_plans: [],
      lesson_plan_topics:[],
      lessons:[],
      dueDates: [
        {
          name: 'Upcoming',
          value: 'up-coming'
        },
        {
          name: 'Past',
          value: 'past'
        },
      ],
      loading: true,
      search: {
        active: 'active'
      },
      statuses: [
        {title: 'Active', 'value': 'active'},
        {title: 'Inactive', 'value': 'in-active'},
      ],
      assignments:[],
      assignmentLoading:false,
    };
  },
  mounted() {
    if(this.checkTeacherMenuAccess('assignments')==false ){
      this.$router.push({name: '404'})
    }
    this.getLessonPlansByTeacherId();
    this.getAllAssignment();

  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },
  },
  methods: {
    createAssignment(){
      this.$router.push({name: "assignment-create"})
    },
    getAllAssignment() {
      this.assignmentLoading=true;
      assignmentService
          .paginate(this.search, this.page).then(response => {
            this.assignments = response.data.data;
            this.page = response.data.meta.current_page;
            this.total = response.data.meta.total;
            this.perPage = response.data.meta.per_page;
        })
          .catch((err) => {

        })
      .finally(() => {
          this.assignmentLoading=false;
      });

    },
    openDialog(assignment) {
      this.$refs["assignment"].showModal(assignment);
    },
    getLessonPlansByTeacherId() {
      this.loading = true;
      academicClassTeacherService.getActiveLessonPlansByTeacherId().then(response => {
        this.lesson_plans = response.data.data;
        this.loading = false;
      }).catch((err) => {
// console.log(err)
      }).finally(() => {
        this.loading = false;

      });
    },
    deleteAcademicYear(id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            assignmentService.delete(id).then(response => {
              this.$snotify.success("Classroom deleted");
              this.__get();
            });
          }
        }
      });
    },
    resetForm() {
      this.search = {
        active: 'active'
      }
      this.__get();
    },
    assignmentSummary(item) {
      this.$router.push(
          {
            name: 'assignment-summary',
            params: {assignment_id: item.id}
          }
      )
    },
  }
};
</script>
